module.exports = __webpack_public_path__ + "img/vending.machine.358eea5c.png";